export default "__VITE_ASSET__DgTxaKZ4__"